import { render } from "./ArrowDownSvg.vue?vue&type=template&id=5aad0c94"
import script from "./ArrowDownSvg.vue?vue&type=script&lang=js"
export * from "./ArrowDownSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__